export const unitAndEst = (deadline, now = Date.now()) => {
  const deadlineDate = Date.parse(deadline);
  const diffSeconds = (deadlineDate - now) / 1000;

  let unit;
  let est;

  if (diffSeconds > 60 * 60 * 24) {
    unit = 'days';
    est = Math.round(diffSeconds / (60 * 60 * 24));
  } else if (diffSeconds > 60 * 60) {
    unit = 'hours';
    est = Math.round(diffSeconds / (60 * 60));
  } else if (diffSeconds > 60) {
    unit = 'minutes';
    est = Math.round(diffSeconds / 60);
  } else {
    unit = 'seconds';
    est = Math.round(diffSeconds);
  }

  return { unit, est };
};



// WEBPACK FOOTER //
// ./app/Assets/js/utils/est.js